module.exports = __webpack_public_path__ + "img/img-1-m-pass-plan@2x.6c0d6292.png";